import { useTheme, useMediaQuery } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  buildCustomTableConfig,
  restoreSingleConfigTable,
  buildTableConfig,
  startRequest,
  stopRequest,
  buildCompLoadings,
  startRequestComp,
  stopRequestComp,
  setSnackbar,
  clearSnackbar,
  removeSnackbar as removeSnackbarAction,
  changeStations,
  changeUnits,
  changeDiff,
  changeStartDate,
  changeEndDate,
  clearSearch,
  tableConfigPageSize,
  tableConfigPage,
  tableConfigSort,
  tableConfigFilter,
  destroyTableConfigs
} from "redux/actions/search/searchActions";

export const useSearch = (props = {}) => {
  const { defaultPageSize } = useSelector(({ search }) => search)
  const dispatch = useDispatch();
  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const md = useMediaQuery(theme.breakpoints.up("md"));

  const startRequestMemorized = useCallback(() => {
    dispatch(startRequest());
  }, [dispatch]);

  const stopRequestMemorized = useCallback(() => {
    dispatch(stopRequest());
  }, [dispatch]);

  const buildCompLoadingsMemorized = useCallback(
    arrayNames => {
      dispatch(buildCompLoadings(arrayNames));
    },
    [dispatch]
  );

  const buildTableConfigMemorized = useCallback(
    (name, page = null) => {
      if (lg) {
        dispatch(buildTableConfig(name, page || defaultPageSize));
      } else if (md) {
        dispatch(buildTableConfig(name, page || 10));
      }
    },
    [dispatch, lg, md, defaultPageSize]
  );

  const buildCustomTableConfigMemorized = useCallback(
    (table, tableConfig) => {
      dispatch(buildCustomTableConfig(table, tableConfig));
    },
    [dispatch]
  );

  const handlePageSizeMemorized = useCallback(
    (e, table) => {
      dispatch(tableConfigPageSize(e, table));
    },
    [dispatch]
  );

  const handlePageMemorized = useCallback(
    (e, table) => {
      dispatch(tableConfigPage(e, table));
    },
    [dispatch]
  );

  const handleSortMemorized = useCallback(
    (e, table) => {
      dispatch(tableConfigSort(e, table));
    },
    [dispatch]
  );

  const handleFilterMemorized = useCallback(
    (e, table) => {
      dispatch(tableConfigFilter(e, table));
    },
    [dispatch]
  );

  const restoreSingleTablesConfigMemorized = useCallback(
    (e, table) => {
      dispatch(restoreSingleConfigTable(e, table));
    },
    [dispatch]
  );

  const destroyTablesConfigMemorized = useCallback(
    () => {
      dispatch(destroyTableConfigs());
    },
    [dispatch]
  );

  const startRequestCompMemorized = useCallback(
    (loadingName) => {
      dispatch(startRequestComp(loadingName));
    },
    [dispatch]
  );

  const stopRequestCompMemorized = useCallback(
    (loadingName) => {
      dispatch(stopRequestComp(loadingName));
    },
    [dispatch]
  );

  const changeStationMemoized = useCallback(
    (stations) => {
      dispatch(changeStations(stations ? stations : []));
    },
    [dispatch]
  );

  const changeUnitsMemorized = useCallback(
    (units) => {
      dispatch(changeUnits(units ? units : []));
    },
    [dispatch]
  );

  const changeDiffMemorized = useCallback(
    (diff) => {
      dispatch(changeDiff(diff ? diff : []));
    },
    [dispatch]
  );

  const changeStartDateMemoized = useCallback(
    (date) => {
      dispatch(changeStartDate(date));
    },
    [dispatch]
  );

  const changeEndDateMemoized = useCallback(
    (date) => {
      dispatch(changeEndDate(date));
    },
    [dispatch]
  );

  const setSnackbarMemorized = useCallback(
    (message, color = "danger", position = "tr") => {
      dispatch(setSnackbar(message, color, position));
    },
    [dispatch]
  );

  const clearSnackbarMemorized = useCallback(() => {
    dispatch(clearSnackbar());
  }, [dispatch]);

  const removeSnackbarMemorized = useCallback((id) => {
    dispatch(removeSnackbarAction(id));
  }, [dispatch]);

  const clearSearchMemorized = useCallback(() => {
    dispatch(clearSearch());
  }, [dispatch]);

  const { configTables } = useSelector(
    ({ search }) => search
  );
  useEffect(() => {
   props?.tableKey && props?.tableKey.length > 0 && !configTables[props?.tableKey] && buildTableConfigMemorized(props?.tableKey);
  }, [])

  return {
    startRequest: startRequestMemorized,
    stopRequest: stopRequestMemorized,
    buildCompLoadings: buildCompLoadingsMemorized,
    buildTableConfig: buildTableConfigMemorized,
    buildCustomTableConfig: buildCustomTableConfigMemorized,
    handlePageSize: handlePageSizeMemorized,
    handlePage: handlePageMemorized,
    handleSort: handleSortMemorized,
    handleFilter: handleFilterMemorized,
    restoreTable: restoreSingleTablesConfigMemorized,
    destroyTableConfigs: destroyTablesConfigMemorized,
    startRequestComp: startRequestCompMemorized,
    stopRequestComp: stopRequestCompMemorized,
    changeStation: changeStationMemoized,
    changeUnits: changeUnitsMemorized,
    changeDiff: changeDiffMemorized,
    changeStartDate: changeStartDateMemoized,
    changeEndDate: changeEndDateMemoized,
    setSnackbar: setSnackbarMemorized,
    clearSnackbar: clearSnackbarMemorized,
    removeSnackbar: removeSnackbarMemorized,
    clearSearch: clearSearchMemorized
  };
};
